"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
var capabilities_1 = require("../ows/capabilities");
var utils_1 = require("../utils");
var LAYER_DOES_NOT_EXIST = function (layerId) {
    return "layer \"".concat(layerId, "\" does not exist");
};
var Base = /** @class */ (function () {
    function Base(url, _a) {
        var _b = _a === void 0 ? { fetch: undefined } : _a, debug = _b.debug, customFetch = _b.fetch, service = _b.service, version = _b.version;
        this.capabilities = {};
        this.debug = debug;
        this.fetch = customFetch || fetch;
        if (service) {
            this.service = service;
        }
        else if (!this.service) {
            this.service = (0, utils_1.parseService)(url, { case: "upper" });
        }
        this.url = url;
        this.version =
            version || new URL(url).searchParams.get("version") || undefined;
    }
    Base.prototype.getCapabilities = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                if (!this.service) {
                    throw new Error("service not set");
                }
                key = (options === null || options === void 0 ? void 0 : options.version) || this.version || "default";
                if (!this.capabilities[key]) {
                    this.capabilities[key] = (0, capabilities_1.getCapabilities)(this.url, {
                        debug: options === null || options === void 0 ? void 0 : options.debug,
                        fetch: this.fetch,
                        service: this.service,
                        version: (options === null || options === void 0 ? void 0 : options.version) || this.version || undefined,
                    });
                }
                return [2 /*return*/, this.capabilities[key]];
            });
        });
    };
    Base.prototype.getLayerIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("".concat(this.constructor.name, " does not implement getLayerIds"));
            });
        });
    };
    Base.prototype.getLayerNames = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error("".concat(this.constructor.name, " does not implement getLayerNames"));
            });
        });
    };
    Base.prototype.hasLayerId = function (layerId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utils_1.hasLayerId;
                        return [4 /*yield*/, this.getLayerIds()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), layerId, options])];
                }
            });
        });
    };
    Base.prototype.hasLayerName = function (layerName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLayerNames()];
                    case 1: return [2 /*return*/, (_a.sent()).includes(layerName)];
                }
            });
        });
    };
    // to-do: check if multiple namespaces share the same layer id
    // in which case, have to be more specific
    Base.prototype.checkLayer = function (layerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hasLayerId(layerId, { strict: false })];
                    case 1:
                        if (!(_a.sent())) {
                            throw new Error(LAYER_DOES_NOT_EXIST(layerId));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Base;
}());
exports.Base = Base;
